import { Component, OnInit, Input } from '@angular/core';
import { Cliente } from '../../cliente/cliente.model';

@Component({
  selector: 'app-usuario-datos-personales-card',
  templateUrl: './usuario-datos-personales-card.component.html',
  styleUrls: ['./usuario-datos-personales-card.component.scss']
})
export class UsuarioDatosPersonalesCardComponent implements OnInit {
  @Input() cliente: Cliente;
  @Input() validacionComponent = false;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-datos-personales-card/usuario-datos-personales-card.component.ts